import React, { Component } from "react";
import { Link } from "react-router-dom";

class What extends Component {
  scrollToFeatures = (e) => {
    e.preventDefault();
    const target = document.getElementById("aiva-features");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  render() {
    return (
      <section id="what-bot">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 aiva-copy">
              <span className="aiva-eyebrow anim_piece">
                Founder Project <span className="aiva-eyebrow-sep">/</span>{" "}
                AI Product
              </span>

              <h2 className="anim_piece">AIVA</h2>

              <p className="aiva-headline anim_piece">
                An agentic AI assistant that gets things done.
              </p>

              <p className="anim_piece">
                AIVA (Artificially Intelligent Virtual Assistant) is an
                AI-powered assistant I designed and built to give businesses a
                customizable, brand-aligned assistant that works across the
                platforms their customers already use. What started as a
                conversational chatbot has evolved into an agentic AI
                product, one built to take multi-step actions, not just
                answer questions.
              </p>

              <div className="aiva-block anim_piece">
                <h5 className="aiva-block-title">The Problem</h5>
                <p>
                  Most chatbots can only answer from a script. Businesses
                  increasingly need an assistant that can reason across
                  multiple steps, call tools, and actually complete a task
                  instead of just describing how to do it.
                </p>
              </div>

              <p className="aiva-solution anim_piece">
                AIVA is built around agentic model integrations, so it can
                plan, call tools, and hand work off between large language
                models such as Claude and GPT. It's also built to work
                alongside OpenClaw, an open-source, model-agnostic autonomous
                agent framework, so agentic workflows can run locally and
                extend across the messaging platforms it supports.
              </p>

              <div className="aiva-cta anim_piece">
                <Link to="/contact" className="btn btn-dark-green waves-effect">
                  Get in Touch
                </Link>
                <a
                  href="#"
                  onClick={this.scrollToFeatures}
                  className="btn btn-outline-dark-green waves-effect"
                >
                  Learn More
                </a>
              </div>
            </div>

            <div className="col-12 col-md-6 aiva-visual-col">
              <div className="aiva-visual anim_piece">
                <div className="chat-frame">
                  <div className="chat-frame-bar">
                    <span className="device-dot"></span>
                    <span className="device-dot"></span>
                    <span className="device-dot"></span>
                    <span className="chat-frame-title">AIVA</span>
                    <span className="chat-frame-badge">Agentic Mode</span>
                  </div>
                  <div className="chat-frame-body">
                    <div className="chat-bubble chat-bubble-user">
                      Can you check if we have a support slot open tomorrow
                      and book it?
                    </div>
                    <div className="chat-bubble chat-bubble-aiva">
                      Checking your calendar and confirming with the
                      customer...
                    </div>
                    <div className="chat-action">
                      <span className="chat-action-dot"></span>
                      Action: Checked calendar &middot; Booked 2:00 PM slot
                    </div>
                    <div className="chat-bubble chat-bubble-aiva">
                      Done. I booked tomorrow at 2:00 PM and sent the
                      customer a confirmation.
                    </div>
                    <div className="chat-integrations">
                      <span className="chat-integrations-label">
                        Powered By
                      </span>
                      <div className="chat-integrations-list">
                        <span>Claude</span>
                        <span>GPT-4</span>
                        <span>OpenClaw</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default What;
